export const kjokkenListe = [
    "Vaske og tømme kjøleskap og fryser for ting som ikke tåler å stå, la kjøleskapet stå på",
    "Best å ikke la det være noe i fryseren pga fare for strømbrudd",
    "Brødboks tom, la lokket stå åpent slik at det ikke blir mugg",
    "Vaske stekeovnen hvis brukt",
    "Vurdere om noe bør kastes i matskuffene. Hvis en stund til neste gjest, kast åpne pakninger",
    "Rense filter i oppvaskmaskinen",
    "Vaske kaffetrakter",
    "Kaffefilteret fjernet?",
    "Grillen børstes innvendig, vaskes utvendig (bruk evt k7 utenpå). Legg på trekket",
    "Hvis Hadeland-glass knuses, la stetten ligge igjen i skapet innpakket (knusegaranti)",
    "Tømme søppel og kaste tomflasker",
    "Sett igjen litt drikkevann til nestemann. Kanskje de ankommer om natten",
]

export const badListe = [
    "Tørk over nede i skuffene",
    "Vask over toalettet og spray med desinfectante i toalettet slik at det ikke utvikles bakterier før det blir vasket hvis lenge til neste gjest",
    "Påse at det ikke drypper noe sted, særlig på det store badet oppe",
    "Rens eventuelt sluket på badene - særlig nede!",
    "Sett ned varmekabler på laveste nivå (skal ikke brukes sommerstid)",
    "Vinduer på alle bad og i hotellfløyen skal være på gløtt",
    "Dørene mellom rommene skal være åpne så det blir gjennomlufting",
    "Søppel tømt?",
    "Sett på alarmene oppe og nede (Siv kan også gjøre det fra app)",
    "Husk at ruteren/internett må være på! (Alarmen går gjennom den)",
    "Lås porten",
    "Sprinkelseng og barnestol i skap ved vinduet stort soverom",
]

export const langAvstandListe = [
    "Trekk ut støpsel til varmtvannsberederne på kjøkkenet (utenfor kjøkkendøren i casinettoen) og det store soverommet (første skap på venstre hånd)",
    "Legg uteputer inn i stuen",
    "Bar og Schous skiltet skal stå inne",
    "Grillen settes inn i casinettoen (avlukket bak kjøkkenet)",
    "Sistemann før jul kan ta ned vimpelen",
]

export const bilListe = [
    "Støvsuge og vaske bilen (vask kan gjøres for ca €2 ved bensinstasjonen på veien mot Frigiliana)",
    "Fylle bensin, full tank - vanlig blyfritt 95",
    "Legg igjen nøkkelen",
    "Parkeres med fronten ut",
    "Koble fra batteriet ved å ta av kontakt på polen",
    "La panseret være åpent ved å legge plastflaske i garasjen mellom",
]

export const genereltListe = [
    "Vask sengetøy*",
    "Re opp sengene til nestemann",
    "Skriv i hytteboken! Derunder reparasjoner, innkjøp eller annet. F.eks. restaurantanmeldelser.",
    "Legg igjen oppholdspenger (skrin på toppen av vitrineskap) og penger til utvask (marmorskrinet i spisestuen)",
]
